<div class="card">
  <div class="card-header d-flex justify-content-between">
    <h4 class="card-title text-primary">
      Today's Time Tracking
    </h4>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12" *ngIf="recordsKeys.length > 0">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th style="min-width: 250px">Employee Name</th>
                <th style="min-width: 250px">Project</th>
                <th style="min-width: 250px">Start Time</th>
                <th style="min-width: 250px">End Time</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let r of recordsKeys">
                <tr>
                  <th>
                    {{ records[r].employee }}
                  </th>
                  <td>{{ records[r].project }}</td>
                  <td>{{ records[r].timeIn }}</td>
                  <td>{{ records[r].timeOut }}</td>
                  <td>
                    <span *ngIf="records[r].arr.length > 0" (click)="records[r].expend = !records[r].expend" class="font-medium-3 font-weight-bolder">+</span>
                  </td>
                </tr>
                <tr>
                  <td colspan="5" class="p-0">
                    <div class="table-responsive" [ngbCollapse]="!records[r].expend">
                      <table class="table">
                        <tbody>
                          <tr *ngFor="let rr of records[r].arr">
                            <td style="min-width: 250px">
                              {{ rr.employee }}
                            </td>
                            <td style="min-width: 250px">{{ rr.project }}</td>
                            <td style="min-width: 250px">{{ rr.timeIn }}</td>
                            <td style="min-width: 250px">{{ rr.timeOut }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-12 text-center" *ngIf="recordsKeys.length == 0 || loading">
        <h3 class="text-muted" *ngIf="recordsKeys.length == 0">
          No records found...
        </h3>
        <div class="spinner-border text-primary" role="status" *ngIf="loading">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</div>